export default function containsSpecialChar(value) {
    var SPECIAL = /[-=+_.?!&@#]/;
    return SPECIAL.test(value);
}
